module.exports = __webpack_public_path__ + "static/img/2015.f888233.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2015.jpg
// module id = 306
// module chunks = 0